import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { ArrowRight } from 'lucide-react';
import { portfolioProjects } from '../../mock';

export default function CompletedProjects() {
  const { lang, t } = useLang();
  const featured = portfolioProjects.slice(0, 4);

  return (
    <section className="bg-[#12151A] py-20 sm:py-28" data-testid="completed-projects-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.completed.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 font-outfit">{t.completed.heading}</h2>
          <p className="text-slate-400 mt-4">{t.completed.desc}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
          {featured.map(p => (
            <div key={p.id} className="group relative overflow-hidden rounded-lg aspect-[4/3]" data-testid={`home-project-${p.id}`}>
              <img src={p.image} alt={`${p.title} - ${p.location}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-[#D4AF37] text-[10px] font-mono uppercase tracking-wider">{p.type}</span>
                <h3 className="text-white font-semibold mt-1 font-outfit">{p.title}</h3>
                <p className="text-slate-400 text-sm">{p.location}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a href="/projects" data-testid="view-all-projects"
            className="group inline-flex items-center gap-3 border border-white/20 hover:border-[#D4AF37]/40 text-white font-semibold px-8 py-4 rounded transition-all hover:bg-white/5">
            {t.completed.viewAll}<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
